import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import {
  IPEmailBuilderSettingsDirective,
  IPEmailBuilderTextEditorMenuDirective,
  TextBlock,
} from "@wlocalhost/ngx-email-builder";
import { IPEmailBuilderUiService } from "libs/ngx-email-builder/src/lib/services";
import { Validators, Editor, Toolbar } from "ngx-editor";

@Component({
  selector: "tail-text-block",
  templateUrl: "text-block.component.html",
  styleUrls: ["text-block.component.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBlockComponent extends TextBlock implements OnInit, OnDestroy {
  override builderUiService = inject(IPEmailBuilderUiService);
  readonly emailBuilderUiService = inject(IPEmailBuilderUiService);
  override settingsPortal!: IPEmailBuilderSettingsDirective;
  emailBuilderEditor!: Editor;
  emailAsideEditor!: Editor;
  override innerText = "";
  private editorAttached = false;
  toolbar: Toolbar = [
    ["bold", "italic"],
    ["underline", "strike"],
    ["code", "blockquote"],
    ["ordered_list", "bullet_list"],
    [{ heading: ["h1", "h2", "h3", "h4", "h5", "h6"] }],
    ["link", "image"],
    ["text_color", "background_color"],
    ["align_left", "align_center", "align_right", "align_justify"],
    ["horizontal_rule", "format_clear"],
  ];

  form = new FormGroup({
    editorContent: new FormControl("Hello world!", Validators.required()),
  });

  get doc(): AbstractControl | null {
    return this.form.get("editorContent");
  }
  onTextChange(value: string) {
    if (!this.editorAttached) {
      this.emailBuilderUiService.attachEditor(this.emailBuilderEditor);
      this.builderUiService.attachSettingsPortal(this.settingsPortal);
      this.editorAttached = true;
    }
  }

  override ngOnInit(): void {
    this.emailBuilderEditor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    });

    this.emailAsideEditor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    });
  }

  override ngOnDestroy(): void {
    this.emailBuilderEditor.destroy();
    this.emailAsideEditor.destroy();
  }
}
